module.exports = __webpack_public_path__ + "static/onshape-phi-cloud-app-813f2561424c8e688606ed82ca051660.png";